export default "__VITE_ASSET__x0wOEEh9__"